<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Đồng bộ dữ liệu Mautic</h1>
      <div class="float-right btn-group">
        <button type="button" class="font-medium f12 btn btn-outline-secondary">
          <i class="bx bx-download"></i>
          <a href="/files/template-upload-mautic.xlsx" style="color: gray" target="_blank"
            >Tải file mẫu</a
          >
        </button>
        <button
          type="button"
          @click="triggerFileUpload"
          :disabled="isUploading"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-import"></i>
          {{ isUploading ? 'Đang tải...' : 'Tải lên file' }}
        </button>
        <button
          type="button"
          @click="openConfigModal"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bxs-cog"></i> Cấu hình
        </button>
        <button
          type="button"
          @click="toggleGlobalSync"
          class="font-medium f12 btn btn-outline-secondary"
          :disabled="isSyncToggleLoading"
        >
          <i
            :class="
              isSyncToggleLoading
                ? 'bx bx-loader-alt bx-spin'
                : isSyncEnabled
                  ? 'bx bx-power-off'
                  : 'bx bx-sync'
            "
          ></i>
          {{
            isSyncToggleLoading ? 'Đang xử lý...' : isSyncEnabled ? 'Tắt đồng bộ' : 'Bật đồng bộ'
          }}
        </button>
        <button
          type="button"
          @click="clearAllData"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-revision"></i> Clear dữ liệu
        </button>
      </div>
    </div>

    <input
      type="file"
      ref="fileInput"
      @change="handleFileUpload"
      accept=".xlsx,.xls,.csv"
      style="display: none"
    />

    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="filters.merchantEmail"
              class="form-control f12 hc-37 text-search"
              placeholder="Email"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.statusSync"
              :options="statusOptions"
              placeholder="Trạng thái"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Ngày gửi lên
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <button
              type="submit"
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              @click="clearSearch"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content">
          <div class="p-10 pt-0">
            <div class="d-flex flex-row">
              <div class="box-header">
                Tổng:
                <strong class="text-primary"
                  >&nbsp;{{ pagination?.total?.toLocaleString('vi-VN') }}</strong
                >
              </div>
            </div>
            <b-table
              hover
              sticky-header
              head-variant="light"
              responsive
              :items="dataTable"
              :fields="fields"
              :fixed="true"
              :bordered="true"
              :busy.sync="isLoading"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle" />
                </div>
              </template>
              <template #empty>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>

              <template #cell(merchantEmail)="{ item }">
                <div>
                  {{ item.merchantEmail || '' }}
                </div>
              </template>

              <template #cell(mauticId)="{ item }">
                <div>
                  {{ item.mauticId || '-' }}
                </div>
              </template>

              <template #cell(statusSync)="{ item }">
                <div class="text-center">
                  <span :class="`badge ${getSyncStatusClass(item.statusSync)}`">
                    {{ getSyncStatusText(item.statusSync) }}
                  </span>
                </div>
              </template>

              <template #cell(contentSync)="{ item }">
                <div class="content-sync-cell">
                  <ul v-if="item.contentSync" class="content-list">
                    <li v-for="(value, key) in parseJsonContent(item.contentSync)" :key="key">
                      <strong>{{ formatKey(key) }}:</strong> {{ value }}
                    </li>
                  </ul>
                  <div v-else>-</div>
                </div>
              </template>

              <template #cell(syncMess)="{ item }">
                <div>
                  {{ item.syncMess || '-' }}
                </div>
              </template>

              <template #cell(historyFieldSync)="{ item }">
                <div>
                  {{ item.historyFieldSync || '-' }}
                </div>
              </template>

              <template #cell(actions)="{ item }">
                <div class="text-center">
                  <button type="button" class="btn btn-sm btn-primary">
                    <!-- @click="syncItem(item)" -->
                    <i class="bx bx-sync"></i> Đồng bộ
                  </button>
                </div>
              </template>
            </b-table>
            <div class="d-flex justify-content-end">
              <b-pagination
                v-model="pagination.page"
                :total-rows="pagination.total"
                :per-page="pagination.limit"
                @change="onChangePage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <ConfigModal
      :visible.sync="showConfigModal"
      @config-saved="onConfigSaved"
      @hidden="onConfigModalHidden"
    />
  </div>
</template>

<script>
  import ConfigModal from './configModal.vue'
  import { showMess } from '@/config/utils'
  import Config from '@/thirdParty/config'
  import { MauticService } from '@/services/mautic.service'
  import { mapGetters } from 'vuex'
  import moment from 'moment'

  export default {
    components: {
      ConfigModal,
    },
    data() {
      return {
        Config,
        filters: {},
        dataUser: JSON.parse(localStorage.getItem('userData')),
        statusOptions: [
          { id: 'NEW', text: 'Mới tạo', class: 'badge-info' },
          { id: 'ERROR', text: 'Lỗi', class: 'badge-danger' },
          { id: 'PROCESSING', text: 'Đang xử lý', class: 'badge-primary' },
          { id: 'DONE', text: 'Hoàn thành', class: 'badge-success' },
          { id: 'FAIL', text: 'Thất bại', class: 'badge-warning' },
          { id: 'EXCLUDE', text: 'Loại trừ', class: 'badge-dark' },
          { id: 'NOT_SYNC', text: 'Chưa sync bên mautic', class: 'badge-secondary' },
        ],
        isLoading: true,
        fields: [
          { key: 'merchantEmail', label: 'Email', sortable: false },
          { key: 'statusSync', label: 'Trạng thái', sortable: false },
          { key: 'contentSync', label: 'Nội dung đồng bộ', sortable: false },
          { key: 'syncMess', label: 'Thông báo đồng bộ', sortable: false },
          { key: 'historyFieldSync', label: 'Lịch sử đồng bộ', sortable: false },
          { key: 'actions', label: 'Hành động', sortable: false },
        ],
        pagination: {
          page: 1,
          limit: 20,
          total: 0,
        },
        dataTable: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
        loaddingDownload: false,
        // Upload file properties
        uploadedData: [],
        isUploading: false,
        showConfigModal: false,

        // [NEW] Thêm các state để quản lý trạng thái của nút đồng bộ
        isSyncEnabled: false, // Trạng thái đồng bộ: true (bật), false (tắt)
        isSyncToggleLoading: false, // Trạng thái loading cho nút bật/tắt
      }
    },
    async created() {
      this.fetchSyncStatus() // [NEW] Gọi hàm lấy trạng thái khi component được tạo
      this.fetchData()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async handleFileUpload(event) {
        const file = event.target.files[0]
        if (!file) return

        // Validate file type
        const allowedTypes = [
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/vnd.ms-excel',
          'text/csv',
        ]
        if (!allowedTypes.includes(file.type)) {
          showMess(
            this,
            'Error',
            'Vui lòng chọn file Excel hoặc CSV',
            'danger',
            'b-toaster-top-right',
            5000
          )
          return
        }

        // Validate file size (10MB)
        const maxSize = 10 * 1024 * 1024
        if (file.size > maxSize) {
          showMess(
            this,
            'Error',
            'Kích thước file không được vượt quá 10MB',
            'danger',
            'b-toaster-top-right',
            5000
          )
          return
        }

        this.isUploading = true

        try {
          const formData = new FormData()
          formData.append('file', file)

          const res = await MauticService.uploadFile(formData)

          if (res.code === 1000 || res.code === 1888) {
            const data = res.data
            // Nếu có dữ liệu thành công
            if (data?.jobId) {
              // Gọi API để lấy danh sách dữ liệu đã import
              await this.fetchData()

              showMess(
                this,
                'Success',
                data.message || 'Tải file thành công',
                'success',
                'b-toaster-top-right',
                5000
              )
              setTimeout(() => {
                this.$router.push('/history-mautic')
              }, 3000)
            }
          } else {
            showMess(
              this,
              'Error',
              res.message || 'Tải file thất bại',
              'danger',
              'b-toaster-top-right',
              5000
            )
          }
        } catch (error) {
          let errorMessage = 'Có lỗi xảy ra khi tải file'

          if (error.response) {
            if (error.response.status === 413) {
              errorMessage = 'File quá lớn'
            } else if (error.response.status === 415) {
              errorMessage = 'Định dạng file không được hỗ trợ'
            } else if (error.response.data?.message) {
              errorMessage = error.response.data.message
            }
          }

          showMess(this, 'Error', errorMessage, 'danger', 'b-toaster-top-right', 5000)
        } finally {
          this.isUploading = false
          // Reset input file
          this.$refs.fileInput.value = ''
        }
      },

      // Method hiển thị modal lỗi
      showErrorModal(errors, successCount, errorCount, totalRows) {
        const h = this.$createElement

        // Tạo nội dung modal
        const errorList = errors.map(error => {
          return h('li', { class: 'mb-2' }, [
            h('strong', error.email),
            h('span', { class: 'text-danger ml-2' }, error.errorMessage),
          ])
        })

        const content = h('div', [
          h('div', { class: 'mb-3' }, [
            h('p', { class: 'mb-1' }, `Tổng số dòng: ${totalRows}`),
            h('p', { class: 'mb-1 text-success' }, `Thành công: ${successCount}`),
            h('p', { class: 'mb-1 text-danger' }, `Lỗi: ${errorCount}`),
          ]),
          h('hr'),
          h('div', { class: 'error-list-container' }, [
            h('h6', 'Danh sách lỗi:'),
            h(
              'ul',
              {
                class: 'list-unstyled',
                style: 'max-height: 300px; overflow-y: auto;',
              },
              errorList
            ),
          ]),
        ])

        this.$bvModal.msgBoxOk(content, {
          title: 'Kết quả import',
          size: 'lg',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: 'Đóng',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
        })
      },
      // [NEW] Phương thức lấy trạng thái đồng bộ hiện tại từ API
      async fetchSyncStatus() {
        this.isSyncToggleLoading = true
        try {
          // Giả định MauticService có phương thức getSyncStatus
          // và trả về { code: 1000, data: { isEnabled: true/false } }
          const res = await MauticService.getSyncStatus()
          if (res.code === 1000) {
            this.isSyncEnabled = res.data.isActivated || false
          }
        } catch (error) {
          // Không hiển thị lỗi cho người dùng để tránh làm phiền
          console.error('Lỗi khi lấy trạng thái đồng bộ:', error)
          // Mặc định là tắt nếu có lỗi
          this.isSyncEnabled = false
        } finally {
          this.isSyncToggleLoading = false
        }
      },

      // [MODIFIED] Sửa đổi logic nút "Đồng bộ tất cả" thành "Bật/Tắt đồng bộ"
      async toggleGlobalSync() {
        const actionText = this.isSyncEnabled ? 'tắt' : 'bật'
        this.$bvModal
          .msgBoxConfirm(`Bạn có chắc chắn muốn ${actionText} cơ chế đồng bộ tự động không?`, {
            title: 'Xác nhận thay đổi',
            okTitle: 'Xác nhận',
            cancelTitle: 'Huỷ',
          })
          .then(async value => {
            if (value) {
              this.isSyncToggleLoading = true
              try {
                const newState = !this.isSyncEnabled
                // Giả định MauticService có phương thức setSyncStatus
                // để bật/tắt cơ chế đồng bộ
                const res = await MauticService.setSyncStatus({ value: newState })

                if (res.code === 1000) {
                  this.isSyncEnabled = newState // Cập nhật trạng thái trên UI
                  showMess(
                    this,
                    'Success',
                    `${actionText.charAt(0).toUpperCase() + actionText.slice(1)} đồng bộ thành công`,
                    'success',
                    'b-toaster-top-right',
                    5000
                  )
                  this.fetchData() // Có thể fetch lại data nếu cần
                } else {
                  showMess(
                    this,
                    'Error',
                    res.message || `Có lỗi khi ${actionText} đồng bộ`,
                    'danger',
                    'b-toaster-top-right',
                    5000
                  )
                }
              } catch (error) {
                showMess(
                  this,
                  'Error',
                  error.response?.data?.message || `Có lỗi xảy ra khi ${actionText} đồng bộ`,
                  'danger',
                  'b-toaster-top-right',
                  5000
                )
              } finally {
                this.isSyncToggleLoading = false
              }
            }
          })
          .catch(() => {})
      },

      // Phương thức syncAllData gốc đã được thay thế bằng toggleGlobalSync
      // Nếu bạn vẫn muốn giữ chức năng "Đồng bộ một lần tất cả", bạn có thể tạo một nút khác
      // và giữ lại phương thức này.

      async clearAllData() {
        this.$bvModal
          .msgBoxConfirm(
            'Bạn có chắc chắn muốn xóa tất cả dữ liệu? Hành động này không thể hoàn tác!',
            {
              title: 'Xác nhận xóa dữ liệu',
              okTitle: 'Xác nhận',
              cancelTitle: 'Huỷ',
              okVariant: 'danger',
            }
          )
          .then(async value => {
            if (value) {
              this.isLoading = true
              try {
                const res = await MauticService.clearAllData()

                if (res.code === 1000) {
                  showMess(
                    this,
                    'Success',
                    'Xóa tất cả dữ liệu thành công',
                    'success',
                    'b-toaster-top-right',
                    5000
                  )
                  this.fetchData()
                } else {
                  showMess(
                    this,
                    'Error',
                    res.message || 'Xóa dữ liệu thất bại',
                    'danger',
                    'b-toaster-top-right',
                    5000
                  )
                }
              } catch (error) {
                showMess(
                  this,
                  'Error',
                  error.response?.data?.message || 'Có lỗi xảy ra khi xóa dữ liệu',
                  'danger',
                  'b-toaster-top-right',
                  5000
                )
              } finally {
                this.isLoading = false
              }
            }
          })
          .catch(() => {})
      },
      openConfigModal() {
        this.showConfigModal = true
      },

      onConfigSaved(mappings) {
        console.log('Config saved:', mappings)
        // Xử lý sau khi lưu config thành công
        // Có thể reload data hoặc update UI
      },

      onConfigModalHidden() {
        console.log('Modal closed')
        // Xử lý sau khi modal đóng
      },
      // async exportExcel() {
      //   try {
      //     this.loaddingDownload = true
      //     await MauticService.dowTemplate({})
      //   } catch (error) {
      //     console.log(error)
      //   } finally {
      //     this.loaddingDownload = false
      //   }
      // },
      transformDate() {
        this.filters.fromDate = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.filters.toDate = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },
      // Upload file methods
      triggerFileUpload() {
        this.$refs.fileInput.click()
      },

      async confirmImport() {
        this.$bvModal
          .msgBoxConfirm('Bạn có chắc chắn muốn import dữ liệu này?', {
            title: 'Xác nhận import',
            okTitle: 'Xác nhận',
            cancelTitle: 'Huỷ',
          })
          .then(async value => {
            if (value) {
              try {
                const res = await MauticService.importData({
                  data: this.uploadedData,
                })

                if (res.code === 1000) {
                  showMess(
                    this,
                    'Success',
                    'Import dữ liệu thành công',
                    'success',
                    'b-toaster-top-right',
                    5000
                  )
                  this.closeUploadedTable()
                  this.fetchData() // Reload lại data chính
                } else {
                  showMess(
                    this,
                    'Error',
                    res.message || 'Import dữ liệu thất bại',
                    'danger',
                    'b-toaster-top-right',
                    5000
                  )
                }
              } catch (error) {
                showMess(
                  this,
                  'Error',
                  error.response?.data?.message || 'Có lỗi xảy ra khi import',
                  'danger',
                  'b-toaster-top-right',
                  5000
                )
              }
            }
          })
          .catch(() => {})
      },
      parseJsonContent(contentSync) {
        try {
          return JSON.parse(contentSync)
        } catch (error) {
          return { 'Nội dung': contentSync }
        }
      },
      formatKey(key) {
        // Chuyển đổi key từ snake_case sang readable format
        const keyMap = {
          business_name: 'Tên doanh nghiệp',
          noti_elec_invoice: 'Thông báo hóa đơn điện tử',
          email: 'Email',
        }
        return keyMap[key] || key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
      },
      syncItem(item) {
        this.$bvModal
          .msgBoxConfirm('Bạn có chắc chắn muốn đồng bộ dữ liệu này?', {
            title: 'Xác nhận đồng bộ',
            okTitle: 'Xác nhận',
            cancelTitle: 'Huỷ',
          })
          .then(async value => {
            if (value) {
              this.showLoading = true
              try {
                const res = await MauticService.syncData({
                  merchantEmail: item.merchantEmail,
                })

                if (res.code === 1000) {
                  showMess(
                    this,
                    'Success',
                    'Đồng bộ dữ liệu thành công',
                    'success',
                    'b-toaster-top-right',
                    5 * 60 * 60
                  )
                  this.fetchData()
                } else {
                  showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
                }
              } catch (error) {
                showMess(
                  this,
                  'Error',
                  error.response?.data?.message || error.response?.message || error.message,
                  'danger',
                  'b-toaster-top-right',
                  5 * 60 * 60
                )
              } finally {
                this.showLoading = false
              }
            }
          })
          .catch(() => {})
      },
      filterInvalidData(data) {
        if (!data || typeof data !== 'object') {
          return {}
        }

        const result = { ...data }
        let hasInvalidValues = false

        for (const key in result) {
          const value = result[key]

          if (value === null || value === undefined || value === '0' || value === '') {
            delete result[key]
            hasInvalidValues = true
          }
        }
        return hasInvalidValues ? result : data
      },
      submitForm() {
        this.pagination.page = 1
        this.fetchData()
      },
      clearSearch() {
        this.filters = {}
        this.fetchData()
      },
      async fetchData() {
        try {
          this.isLoading = true
          const payload = this.filterInvalidData(this.filters)

          const res = await MauticService.getList({
            ...payload,
            page: this.pagination.page,
            limit: this.pagination.limit,
          })
          if (res.code === 1000) {
            this.dataTable = res.data.content || []
            this.pagination.total = res.data.totalItems ?? 0
          }
        } catch (error) {
          showMess(
            this,
            'Error',
            error.response?.data?.message || error.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },
      onChangePage(pageIndex) {
        this.pagination.page = pageIndex
        this.fetchData()
      },
      getSyncStatusClass(status) {
        const statusItem = this.statusOptions.find(item => item.id === status)
        return statusItem?.class || 'badge-secondary'
      },
      getSyncStatusText(status) {
        const statusItem = this.statusOptions.find(item => item.id === status)
        return statusItem?.text || 'Không xác định'
      },
    },
  }
</script>

<style scoped>
  .content-sync-cell {
    max-width: 300px;
    word-wrap: break-word;
  }

  .content-list {
    margin: 0;
    padding-left: 20px;
    font-size: 12px;
    line-height: 1.4;
  }

  .content-list li {
    margin-bottom: 2px;
  }

  .content-list strong {
    color: #495057;
  }

  .error-list-container {
    font-size: 14px;
  }

  .error-list-container ul {
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 10px;
    background-color: #f8f9fa;
  }

  .error-list-container li {
    padding: 5px 0;
    border-bottom: 1px solid #e9ecef;
  }

  .error-list-container li:last-child {
    border-bottom: none;
  }
</style>
